<template>
    <div class="booking-slide">
        <h3
            class="mx-auto font-sans font-medium text-center text-blue-500 h2"
            style="max-width: 250px;"
        >
            {{ ui.review.heading }}
        </h3>
        <p v-if="ui.review.text" class="mt-6 font-normal text-center text-blue-500">
            {{ ui.review.text }}
        </p>

        <ReviewSection
            heading="Appointment Service"
            :fields="[
                {
                    label: 'Appointment Type',
                    data: serviceDisplayTitle
                },
                {
                    label: 'New Patient',
                    data: newPatient ? 'Yes' : 'No'
                }
            ]"
            @edit="$emit('step-to', 0)"
        />

        <ReviewSection
            heading="Appointment Location"
            :fields="[
                {
                    label: 'Appointment Location',
                    data: location.locationName
                }
            ]"
            @edit="$emit('step-to', 1)"
        />

        <ReviewSection
            heading="Appointment Selection"
            :fields="[
                {
                    label: practitionerType,
                    data: practitionerName
                },
                {
                    label: 'Appointment Time & Date',
                    data: appointmentDateTime
                }
            ]"
            @edit="$emit('step-to', 2)"
        />

        <ReviewSection
            heading="Your Details"
            :fields="[
                {
                    label: 'First name',
                    data: details.firstName
                },
                {
                    label: 'Last name',
                    data: details.lastName
                },
                {
                    label: 'Date of birth',
                    data: details.dob
                },
                {
                    label: 'Mobile number',
                    data: details.phoneNumber
                },
                {
                    label: 'Member number',
                    data: details.membershipNumber
                },
                {
                    label: 'Person number (see back of card)',
                    data: details.hicapsCode
                }
            ]"
            @edit="$emit('step-to', 3)"
        />

        <p v-if="ui.review.disclaimer" class="mt-8 small text-grey-500 sm:mt-14">
            {{ ui.review.disclaimer }}
        </p>

        <button
            class="w-full mt-10 btn"
            :class="{
                'btn--loading text-blue-500': isLoading
            }"
            @click="submit"
        >
            Confirm & Submit
        </button>
    </div>
</template>

<script>
import { DateTime } from 'luxon';
import { toDateString, toTimeString } from '@/../vue/online-booking/utils/dates';
import ServiceTypeUtils from '@/../vue/online-booking/mixins/service-type-utils';
import ReviewSection from '@/../vue/online-booking/components/ReviewSection.vue';

export default {
    components: {
        ReviewSection
    },

    mixins: [ServiceTypeUtils],

    props: {
        serviceType: {
            type: String,
            required: true
        },
        newPatient: {
            type: Boolean,
            required: true
        },
        details: {
            type: Object,
            required: true
        },
        location: {
            type: Object,
            required: true
        },
        appointment: {
            type: Object,
            required: true
        },
        practitioner: {
            type: Object,
            required: true
        },
        ui: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({}),

    computed: {
        over65() {
            return DateTime.fromFormat(this.details.dob, 'dd/MM/yyyy').diffNow('years').years < -65;
        },
        practitionerName() {
            return `${this.practitioner.title} ${this.practitioner.firstName} ${this.practitioner.surname}`;
        },
        appointmentDateTime() {
            const time = toTimeString(this.appointment.appointmentTime);
            const day = toDateString(this.appointment.appointmentDate, 'cccc');
            const date = toDateString(this.appointment.appointmentDate);
            return `${time}, ${day} ${date}`;
        }
    },

    methods: {
        submit() {
            if (!this.isLoading) this.$emit('complete');
        }
    }
};
</script>
